export enum SendOnBehalfOf {
  KAD_ACCOUNT = 'KAD_ACCOUNT',
  DOC_SENDER = 'DOC_SENDER',
  SPECIFIC_USER = 'SPECIFIC_USER',
}
